package one.healthium.life.presentation.navigation.today

import androidx.compose.runtime.Composable
import one.healthium.life.presentation.feature.today.TodayScreen

@Composable
fun TodayContent(
    component: TodayComponent,
) {
    TodayScreen(component)
}